module.exports = __webpack_public_path__ + "static/media/Flamingo Logo.30d18e9b.png";